module.exports = __webpack_public_path__ + "img/BannerPatHome3.24e039a5.webp";